<template>
    <div class="pay-container">
        <div class="product-info">
            <h3>Knowit Credits Charge: {{ charge_description }}</h3>
            <h1>US${{ amount }}</h1>
        </div>
        <div id="checkout">
            <!-- Checkout will insert the payment form here -->
        </div>
    </div>
</template>

<script>
import { postRequest } from '@/apis/front'
export default {
    data() {
        return {
            order_id: this.$route.query.order_id,
            order_type: this.$route.query.order_type || "collection",
            user_id: "",
            amount: "",
            currency: "",
            customer_id: '-1',
            charge_description: "",
            checkoutInstance: null,
            isInitializing: false
        };
    },
    mounted() {
        this.requestOrderInfo()
    },
    beforeDestroy() {
        if (this.checkoutInstance) {
            this.checkoutInstance.destroy();
            this.checkoutInstance = null;
        }
    },
    methods: {

        async requestOrderInfo() {
            let response = null
            if(this.order_type == "collection"){
                response = await postRequest('getCollectionOrder', {  order_id: this.order_id})                
            }else if(this.order_type == "post"){
                response = await postRequest('getPostOrder', {  order_id: this.order_id})                
            }else if(this.order_type == 'bundle'){
                response = await postRequest('getBundleOrder', {  order_id: this.order_id})                
            }else if(this.order_type == 'token'){
                response = await postRequest('getTokenOrder', {  order_id: this.order_id})                
            }else if(this.order_type == 'subscription'){
                response = await postRequest('getSubscriptionOrder', {  order_id: this.order_id})                
            }

            let order = response.data.data
            if (!order) {
                this.$message.error('Order not found')
                console.error('Order data is undefined or null')
                return
            }
            this.handleOrderData(this.order_id, order)
        },
        handleOrderData(order_id, order) {
            if (!order) {
                this.$message.error('Invalid order data')
                return
            }
            let amount = order.usd_price
            this.amount = Number(amount).toFixed(2)
            this.charge_description = order.product_name || "500 credits"

            let line_items = []
            let customer_id = '-1'
            if(this.order_type == 'subscription'){
                if(order.customer_id && order.customer_id !=''){
                    customer_id = order.customer_id
                }
                 line_items = [{
                                price: order.plan_id,
                                quantity: 1,
                            }]
            }else {
                line_items = [{
                                price_data: {
                                    currency: "usd",
                                    product_data: {
                                        name: order.product_name,
                                    },
                                    unit_amount: amount * 100,
                                },
                                quantity: 1,
                            }]
            }
            this.pay(order_id, line_items, this.order_type, customer_id);
        },

        async pay(order_id, line_items, order_type, customer_id) {
            if (this.isInitializing) return;
            this.isInitializing = true;

            try {
                if (this.checkoutInstance) {
                    this.checkoutInstance.destroy();
                    this.checkoutInstance = null;
                }

                // Dynamically load Stripe if not already loaded
                if (!window.Stripe) {
                    await new Promise((resolve, reject) => {
                        const script = document.createElement('script');
                        script.src = 'https://js.stripe.com/v3/';
                        script.onload = resolve;
                        script.onerror = reject;
                        document.head.appendChild(script);
                    });
                }
                const stripe = window.Stripe(
                    "pk_live_51P128qP6BucL4HOz2SJY6gWLATlcK5rGdNTnePD780jhsy6ZLf7ZxIHxRE1oBLk9pchjvIoqHUwnPPGB10DmtGOO00yikhqAr0"
                );

                let request_url = 'https://web-backend-sg.knowit.today/Stripe/StripeEmbedPay.php'
                if(order_type == 'subscription'){
                    request_url = 'https://web-backend-sg.knowit.today/Stripe/StripeSubscriptionEmbedPay.php'
                }

                const fetchClientSecret = async () => {
                    const response = await fetch(
                        request_url,
                        {
                            method: "POST",
                            headers: { "Content-Type": "application/json" },
                            body: JSON.stringify({
                                order_id: order_id,
                                line_items: line_items,
                                order_type: order_type,
                                customer_id: customer_id
                            }),
                        }
                    );

                    const text = await response.text();
                    let result;
                    try {
                        result = JSON.parse(text);
                    } catch (e) {
                        console.error('Backend returned non-JSON response:', text);
                        throw new Error('Backend error: ' + text.substring(0, 200));
                    }

                    if (result.error) {
                        console.error('Backend error:', result);
                        throw new Error(result.message || result.error);
                    }

                    const { clientSecret } = result;
                    return clientSecret;
                };

                this.checkoutInstance = await stripe.initEmbeddedCheckout({
                    fetchClientSecret,
                });

                this.checkoutInstance.mount("#checkout");
            } catch (e) {
                console.error('Payment initialization failed:', e);
                this.$message.error('Payment initialization failed');
            } finally {
                this.isInitializing = false;
            }
        },
    },
};
</script>

<style scoped>
.pay-container {
    min-height: 100vh;
    width: 100%;
    display: flex;
}

.product-info {
    flex: 1;
    background-color: #409EFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    color: white;
}

.product-info h3 {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
}

.product-info h1 {
    font-size: 48px;
    font-weight: bold;
    margin: 0;
}

#checkout {
    flex: 1;
    background-color: white;
    padding: 60px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

#checkout > * {
    width: 100%;
    max-width: 500px;
}

@media (max-width: 768px) {
    .pay-container {
        flex-direction: column;
    }
}
</style>